<template>
    <div class="pay-situation-dowanload-container">
		<div class="content">
			<div class="card-wrapper" v-for="(item, index) in list" :key="index">
				<mobile-card :show-title="false" :show-footer="true">
					<template slot="content">
						<div class="flex-form-info">
							<span>收费项目</span>
							<span>{{item.itemName}}</span>
						</div>

						<div class="flex-form-info">
							<span>交费金额</span>
							<span class="money-item">{{item.payMoney | formatMoney}}</span>
						</div>

						<div class="flex-form-info">
							<span>交费日期</span>
							<span>{{item.payTime }}</span>
						</div>

						<div class="flex-form-info">
							<span>发票号码</span>
							<span>{{item.ticketNum}}</span>
						</div>


					</template>

					<template slot="footer">
						<div class="flex-form-footer">
							<!--<div class="flex-form-btn" @click="download(item)">
								<van-icon name="down"/>
								<span>下载发票</span>
							</div>-->
							<a class="flex-form-btn" target="_blank" :href="item.url">下载发票</a>
						</div>
					</template>
				</mobile-card>
			</div>
		</div>

        <div class="footer">
			<div class="footer-bar">
				<mobile-button color="#005423" @click="onBack">返回上一级</mobile-button>
			</div>
        </div>
    </div>
</template>

<script>
    import log from "utils/log"
	// import {getState} from "utils/state";
	import storage from 'good-storage'
    import MobileCard from "components/mobile-card/index";
    import apiPaySituation from "api/pay-situation";
	import MobileButton from "components/mobile-button/index";
	import utils from "@/utils/util";

    export default {
        components: {MobileButton, MobileCard},

        data() {
            return {
                payItem: {},
                list: [],
            }
		},

        activated() {
            this.getPayItem()
		},

        methods: {
            getPayItem() {
                // let item = getState('pay-item')
                let payItem = storage.session.get('pay-item')
                this.payItem = payItem
                let param = {
                    arrearId: payItem.arrearId,
                    orderNo: payItem.orderNo
                }
                apiPaySituation.ticket(param).then(res => {
					this.list = res.data || []
					this.list.forEach(item => {
						item.url = apiPaySituation.getTicketImgUrl(item.ticketCode, item.ticketNum)
					})
                })
			},

            download(item) {
                let param = {
                    busNo: item.ticketNum,
                }
                apiPaySituation.download(param).then(res => {
                    let url = res.data || ''
                    if (utils.isNotEmpty(url)) {
                        window.open(url)
                    }
                })
			},

            onBack() {
                this.$router.back()
			},

            // test() {
            //     this.list = [
            //         {
            //             itemName: '23112',
            //             payMoney: '41432',
            //             payTime: '12312',
            //             ticketNum: 'dsfasd',
            //         },
            //         {
            //             itemName: '23112',
            //             payMoney: '41432',
            //             payTime: '12312',
            //             ticketNum: 'dsfasd',
            //         },
            //         {
            //             itemName: '23112',
            //             payMoney: '41432',
            //             payTime: '12312',
            //             ticketNum: 'dsfasd',
            //         },
            //     ]
            // }
        },
    }
</script>

<style lang='scss' scoped>
    /*.flex-form-info {*/
    /*    padding: 5px;*/
    /*    display: flex;*/
    /*    justify-content: space-between;*/
    /*}*/

    /*.flex-form-footer {*/
    /*    padding: 5px;*/
    /*    display: flex;*/
    /*    justify-content: flex-end;*/

    /*    .flex-form-btn {*/
    /*        color: #3b7a53;*/
    /*        margin: 10px 10px 10px 0;*/
    /*        display: flex;*/
    /*        align-items: center;*/
    /*    }*/
    /*}*/

    /*.money-item {*/
    /*    color: #3b7a53;*/
    /*}*/
</style>
